import React, {useState, useEffect} from 'react';
import styled from 'styled-components';

import {colors} from '../../styles';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    line-height: 18px;
    span {
        margin-right: 0.75rem;
        cursor: pointer;
    }

    :active,
    :focus {
        box-shadow: none;
        -webkit-tap-highlight-color: transparent;
    }
`;

const SwitchContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0;
    background-color: ${props => (props.active ? colors.pink : '#444')};
    width: 48px;
    height: 24px;
    border-radius: 48px;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
`;

const Handle = styled.div`
    width: 18px;
    height: 18px;
    background-color: #fff;
    border-radius: 100%;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    ${props =>
        props.active
            ? `
        margin-left: 27px;
    `
            : `margin-left:3px;`}
    transition: all 0.15s ease-in-out;
`;

const Switch = ({label, value, name, onChange, ...props}) => {
    const [isActive, setIsActive] = useState(value || false);

    const handleToggle = e => {
        setIsActive(!isActive);
    };

    useEffect(() => {
        onChange && onChange(isActive);

        //eslint-disable-next-line
    }, [isActive]);

    return (
        <Container {...props} onClick={e => handleToggle(e)}>
            {label && <span>{label}</span>}
            <SwitchContainer active={isActive}>
                <Handle active={isActive} />
            </SwitchContainer>
        </Container>
    );
};

export default Switch;
